module.exports = "https://cdn.dove.it/_next/static/public/assets/living-room-small.a2fcd35520d07872173d3b1ef357a3b8.jpg";